import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProblemSolution from "./components/ProblemSolution";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Testimonials from "./components/Testimonials";
import WhyChooseUs from "./components/WhyChooseUs";
import Founder from "./components/Founder";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import DownloadPage from "./pages/DownloadPage";
import AboutPage from "./pages/AboutPage";
import { Toaster } from "./components/ui/toaster";

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <ProblemSolution />
      <Services />
      <Projects />
      <Testimonials />
      <WhyChooseUs />
      <Founder />
      <ContactForm />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App bg-gray-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
